/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import './countdown.scss';

const Countdown = (props) => {
	const { endGame, timestamp } = props;

	//define state
	const [time, setTime] =
		useState(/* {
		months: ms.getMonth(),
		days: Math.floor(ms / (24 * 60 * 60 * 1000)),
		hours: ms.getHours(),
		minutes: ms.getMinutes(),
		seconds: ms.getSeconds(),
	} */);

	//const { days, hours, minutes, seconds, months } = time;
	// Mapping the date values to radius values
	/* const monthRadius = mapNumber(months, 12, 0, 0, 289.0265);
	const daysRadius = mapNumber(days, 30, 0, 0, 289.0265);
	const hoursRadius = mapNumber(hours, 24, 0, 0, 289.0265);
	const minutesRadius = mapNumber(minutes, 60, 0, 0, 289.0265);
	const secondsRadius = mapNumber(seconds, 60, 0, 0, 289.0265); */

	useEffect(() => {
		const interval = setInterval(() => {
			let then;

			if (!timestamp) {
				let parsed = endGame.split('.');
				then = new Date(parsed[2], parsed[1] - 1, parsed[0]);
			} else {
				then = new Date(timestamp);
				//then.setMilliseconds(timestamp);
			}

			const now = new Date(Date.now());
			const countdown = then - now;
			const ms = new Date(countdown);

			const months = ms.getMonth();
			const days = Math.floor(ms / (24 * 60 * 60 * 1000));
			const hours = ms.getUTCHours(); //Math.floor(ms / (1000 * 60 * 60));
			const minutes = ms.getMinutes();
			const seconds = ms.getSeconds();

			setTime({
				days: days,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
				months: months,
			});
		}, 1000);

		return () => {
			if (interval) {
				clearInterval(interval);
			}
		};
	}, []);

	return (
		<div className="counter">
			<div className="countdown-wrapper">
				{/* <div className="countdown-item">
					<SVGCircle fill="#e3612a" radius={months !== 0 ? monthRadius : 289.0265} />
					{months}
				</div> */}

				<div className="countdown-item">
					{/* <SVGCircle fill="#e3612a" radius={days !== 0 ? daysRadius : 289.0265} /> */}
					{time?.days}
					<span>Days</span>
				</div>

				<div className="countdown-item">
					{/* <SVGCircle fill="#e3612a" radius={hours !== 0 ? hoursRadius : 289.0265} /> */}
					{time?.hours}
					<span>Hours</span>
				</div>

				<div className="countdown-item">
					{/* <SVGCircle fill="#e9c134" radius={minutes !== 0 ? minutesRadius : 289.0265} /> */}
					{time?.minutes}
					<span>Minutes</span>
				</div>

				<div className="countdown-item">
					{/* <SVGCircle fill="#e9c134" radius={seconds !== 0 ? secondsRadius : 289.0265} /> */}
					<div>{time?.seconds}</div>
					<span>Seconds</span>
				</div>
			</div>
			{/* <div className="counter-days">
				<div className="background" />
				<div className="date">Months</div>
				<div className="date">Days</div>
				<div className="date">Hours</div>
				<div className="date">Minutes</div>
				<div className="date">Seconds</div>
			</div> */}
		</div>
	);
};

const SVGCircle = (props) => {
	const { radius, fill } = props;

	return (
		<svg className="progress" viewBox="0 0 100 100">
			<defs>
				<linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
					<stop offset="0%" stopColor="#006239" />
					<stop offset="100%" stopColor="#006239" />
				</linearGradient>
			</defs>
			<circle className="progress_meter" cx="50" cy="50" r="46" fill="none" strokeWidth="8" />
			<circle
				className="progress_value"
				style={{ strokeDashoffset: radius }}
				cx="50"
				cy="50"
				r="46"
				fill="none"
				stroke="url(#gradient)"
				//strokeDashoffset={radius}
				strokeWidth="3"
			/>
		</svg>
	);
};

/*********** generate svg circle ****************/
function mapNumber(number, in_min, in_max, out_min, out_max) {
	return ((number - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

/*********** generate svg circle ****************/

export default Countdown;
